import React, {useState} from 'react';
import {StatesButtonStates} from 'wix-ui-tpa/cssVars';
import {AdditionalDetailsStepDataHook} from '../AdditionalDetailsStep';
import {NextStepButton} from '../../../StepsManager/Components/NextStepButton/NextStepButton';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {AdditionalDetailsForm} from './AdditionalDetailsForm';
import {classes} from './AdditionalDetailsStepOpen.st.css';
import {useAdditionalDetailsData} from './WithAdditionalDetailsData';

export const AdditionalDetailsStepOpenDataHook = {
  formsList: 'AdditionalDetailsStepOpen.formsList',
  continueButton: 'AdditionalDetailsStepOpen.continueButton',
};

export const AdditionalDetailsStepOpen = () => {
  const localeKeys = useLocaleKeys();
  const [isStepTransition, setIsStepTransition] = useState(false);

  const {
    checkoutStore: {cart},
  } = useControllerProps();
  const {continueToNextStep, validateAllForms} = useAdditionalDetailsData();

  const onStepTransition = async () => {
    setIsStepTransition(true);
    const isAllFormsValid = await validateAllForms();

    if (!isAllFormsValid) {
      setIsStepTransition(false);
      return;
    }

    continueToNextStep();
  };

  return (
    <div data-hook={AdditionalDetailsStepDataHook.open}>
      <ol className={classes.eventList} data-hook={AdditionalDetailsStepOpenDataHook.formsList}>
        {cart.forms!.map((form) => (
          <AdditionalDetailsForm key={form.id} form={form} />
        ))}
      </ol>

      <NextStepButton
        onClick={() => void onStepTransition()}
        text={localeKeys.checkout.continue_button_label()}
        dataHook={AdditionalDetailsStepOpenDataHook.continueButton}
        disabled={isStepTransition}
        buttonState={
          isStepTransition ? /* istanbul ignore next */ StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE
        }
      />
    </div>
  );
};
